const PROVIDER_LINKS = {
  bullhorn: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5495785-setting-up-using-the-bullhorn-integration#h_e29508df67",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5495785-setting-up-using-the-bullhorn-integration#h_e63573bc27",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5495785-setting-up-using-the-bullhorn-integration#h_beb4e5133f",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5495785-setting-up-using-the-bullhorn-integration#h_90d2b79574",
  },
  cats: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5863962-setting-up-using-the-cats-integration#h_7992ae0994",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5863962-setting-up-using-the-cats-integration#h_e1287ee412",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5863962-setting-up-using-the-cats-integration#h_69c4508aa0",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5863962-setting-up-using-the-cats-integration#h_e5599862b0",
  },
  crelate: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5657113-setting-up-using-the-crelate-integration#h_9d74cae557",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5657113-setting-up-using-the-crelate-integration#h_0ba2934c13",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5657113-setting-up-using-the-crelate-integration#h_86a2621f7f",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5657113-setting-up-using-the-crelate-integration#h_6aa4ea6b54",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5657113-setting-up-using-the-crelate-integration#h_ff3787c4f3",
  },
  eboss: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5916509-setting-up-the-eboss-integration#h_cc8074005a",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5916509-setting-up-the-eboss-integration#h_5e3e20fb94",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5916509-setting-up-the-eboss-integration#h_38fc11234a",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5916509-setting-up-the-eboss-integration#h_1c14e3e811",
  },
  ezekia: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5727928-setting-up-using-the-ezekia-integration#h_9054987448",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5727928-setting-up-using-the-ezekia-integration#h_bae298270f",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5727928-setting-up-using-the-ezekia-integration#h_65bf7695de",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5727928-setting-up-using-the-ezekia-integration#h_9be901c1d3",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5727928-setting-up-using-the-ezekia-integration#h_b3261ab025",
  },
  greenhouse: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5519568-setting-up-using-the-greenhouse-integration#h_fd140446c8",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5519568-setting-up-using-the-greenhouse-integration#h_3d80a04e4d",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5519568-setting-up-using-the-greenhouse-integration#h_51ab5fe02f",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5519568-setting-up-using-the-greenhouse-integration#h_605367027d",
  },
  invenias: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5653011-setting-up-using-the-invenias-integration#h_9a4c38eb26",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5653011-setting-up-using-the-invenias-integration#h_e0c8991bdf",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5653011-setting-up-using-the-invenias-integration#h_a913372761",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5653011-setting-up-using-the-invenias-integration#h_e0fe60afbc",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5653011-setting-up-using-the-invenias-integration#h_f182919cff",
  },
  jobadder: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5643209-setting-up-using-the-jobadder-integration#h_726f9b5b9b",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5643209-setting-up-using-the-jobadder-integration#h_dab109ec05",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5643209-setting-up-using-the-jobadder-integration#h_fb02f17242",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5643209-setting-up-using-the-jobadder-integration#h_f92bc6e5fc",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5643209-setting-up-using-the-jobadder-integration#h_0d96a2f4ec",
  },
  lever: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5660514-setting-up-using-the-lever-integration#h_ae8a2bf8a8",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5660514-setting-up-using-the-lever-integration#h_5144ef146a",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5660514-setting-up-using-the-lever-integration#h_86448d302c",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5660514-setting-up-using-the-lever-integration#h_e778c13319",
  },
  loxo: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5727657-setting-up-using-the-loxo-integration#h_a1db06cb4c",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5727657-setting-up-using-the-loxo-integration#h_90df88a073",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5727657-setting-up-using-the-loxo-integration#h_f280d99972",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5727657-setting-up-using-the-loxo-integration#h_ef60a914e8",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5727657-setting-up-using-the-loxo-integration#h_7d073cc670",
  },
  pcrecruiter: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6225768-setting-up-using-the-pcrecruiter-integration#h_dc8a766099",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6225768-setting-up-using-the-pcrecruiter-integration#h_bdfce2ad58",
    contactStages:
      "https://help.sourcewhale.app/en/articles/6225768-setting-up-using-the-pcrecruiter-integration#h_9744bfcf90",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6225768-setting-up-using-the-pcrecruiter-integration#h_9da92caec1",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/6225768-setting-up-using-the-pcrecruiter-integration#h_d807b52bc2",
  },
  recruitcrm: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5892942-setting-up-using-the-recruit-crm-integration#h_b3c5278998",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5892942-setting-up-using-the-recruit-crm-integration#h_08c5046aa1",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5892942-setting-up-using-the-recruit-crm-integration#h_ddf1496069",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5892942-setting-up-using-the-recruit-crm-integration#h_f6c51460e5",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5892942-setting-up-using-the-recruit-crm-integration#h_c187c83eb4",
  },
  recruiterflow: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5772628-setting-up-using-the-recruiterflow-integration#h_86b4998f20",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5772628-setting-up-using-the-recruiterflow-integration#h_4b521311a9",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5772628-setting-up-using-the-recruiterflow-integration#h_07aa45f2f8",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5772628-setting-up-using-the-recruiterflow-integration#h_2d2cd2e654",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5772628-setting-up-using-the-recruiterflow-integration#h_33f7518f7f",
  },
  salesforce: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5913848-setting-up-the-salesforce-integration#h_f188f54cab",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5913848-setting-up-the-salesforce-integration#h_f47c433aa8",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5913848-setting-up-the-salesforce-integration#h_b252e842f6",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5913848-setting-up-the-salesforce-integration#h_a18a9c99cf",
  },
  smartrecruiters: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5461112-setting-up-using-the-smartrecruiters-integration#h_62424105e5",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5461112-setting-up-using-the-smartrecruiters-integration#h_388dec36d4",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5461112-setting-up-using-the-smartrecruiters-integration#h_09996404d7",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5461112-setting-up-using-the-smartrecruiters-integration#h_ac0c3e0b14",
  },
  vincere: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/4542068-setting-up-using-the-vincere-integration#h_8d5eb3da78",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/4542068-setting-up-using-the-vincere-integration#h_1d73207a38",
    contactStages:
      "https://help.sourcewhale.app/en/articles/4542068-setting-up-using-the-vincere-integration#h_815a961a05",
    contactFields:
      "https://help.sourcewhale.app/en/articles/4542068-setting-up-using-the-vincere-integration#h_f36f6b551b",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/4542068-setting-up-using-the-vincere-integration#h_3cebe3674d",
  },
  workable: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5728318-setting-up-the-workable-integration#h_37a83b3ed1",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5728318-setting-up-the-workable-integration#h_84a53b41ba",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5728318-setting-up-the-workable-integration#h_6d1febe952",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5728318-setting-up-the-workable-integration#h_cec2a5e5b2",
  },
  "zoho-recruit": {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5728085-setting-up-using-the-zoho-recruit-integration#h_fe1ebc1c47",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5728085-setting-up-using-the-zoho-recruit-integration#h_7bdc81ff58",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5728085-setting-up-using-the-zoho-recruit-integration#h_0c241a2360",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5728085-setting-up-using-the-zoho-recruit-integration#h_00d78f745c",
  },
  clickup: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5916714-setting-up-the-clickup-integration#h_927d2b4104",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5916714-setting-up-the-clickup-integration#h_c08979b45b",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5916714-setting-up-the-clickup-integration#h_ca29608523",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5916714-setting-up-the-clickup-integration#h_82e5d0ab9a",
  },
  pipedrive: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5917976-setting-up-the-pipedrive-integration#h_5d28ccfec5",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5917976-setting-up-the-pipedrive-integration#h_90b690320f",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5917976-setting-up-the-pipedrive-integration#h_fe840589fa",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5917976-setting-up-the-pipedrive-integration#h_a82a523245",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5917976-setting-up-the-pipedrive-integration#h_3272d85d13",
  },
  podio: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5919686-setting-up-the-podio-integration#h_2164fd9bfd",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5919686-setting-up-the-podio-integration#h_87a0cafec7",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5919686-setting-up-the-podio-integration#h_ad7f39d7d1",
  },
  kortivity: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5925946-setting-up-the-kortivity-integration#h_f78f8a3b8d",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5925946-setting-up-the-kortivity-integration#h_1a73febdfc",
  },
  teamtailor: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5951243-setting-up-using-the-teamtailor-integration#h_069022563e",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5951243-setting-up-using-the-teamtailor-integration#h_b3ab5938b2",
    contactStages:
      "https://help.sourcewhale.app/en/articles/5951243-setting-up-using-the-teamtailor-integration#h_413cdfc012",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5951243-setting-up-using-the-teamtailor-integration#h_c6b9012e88",
  },
  comeet: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6009356-setting-up-the-comeet-integration#h_e015baadf4",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6009356-setting-up-the-comeet-integration#h_f5b29476e9",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6009356-setting-up-the-comeet-integration#h_6050c1c2a7",
  },
  tracker: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6108786-setting-up-using-the-tracker-integration#h_c5f0d93850",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6108786-setting-up-using-the-tracker-integration#h_a101363320",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6108786-setting-up-using-the-tracker-integration#h_1ac856aec3",
  },
  jazzhr: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6009362-setting-up-the-jazzhr-integration#h_fdf4e7161d",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6009362-setting-up-the-jazzhr-integration#h_fadac4afb6",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6009362-setting-up-the-jazzhr-integration#h_20f6970e40",
  },
  itris: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7863926-setting-up-using-the-itris-integration#h_4499481ef6",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7863926-setting-up-using-the-itris-integration#h_09e83c6634",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7863926-setting-up-using-the-itris-integration#h_69be6509f0",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7863926-setting-up-using-the-itris-integration#h_d64baf66f4",
  },
  copper: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7936274-setting-up-using-the-copper-integration#h_d33034b020",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7936274-setting-up-using-the-copper-integration#h_fff367cc9f",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7936274-setting-up-using-the-copper-integration#h_e18f5265f4",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7936274-setting-up-using-the-copper-integration#h_826077a148",
  },
  clockwork: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7936478-setting-up-using-the-clockwork-integration#h_8b63057b70",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7936478-setting-up-using-the-clockwork-integration#h_0249a46d24",
    contactStages:
      "https://help.sourcewhale.app/en/articles/7936478-setting-up-using-the-clockwork-integration#h_ea1127e668",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7936478-setting-up-using-the-clockwork-integration#h_d4241be77d",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7936478-setting-up-using-the-clockwork-integration#h_0b71a95c7e",
  },
  chameleoni: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7936601-setting-up-using-the-chameleon-i-integration#h_ed0608ff69",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7936601-setting-up-using-the-chameleon-i-integration#h_bd7d9b321e",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7936601-setting-up-using-the-chameleon-i-integration#h_0ef5b42e27",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7936601-setting-up-using-the-chameleon-i-integration#h_3ae5d06954",
  },
  breezy: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7936681-setting-up-using-the-breezy-hr-integration#h_93af00fa27",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7936681-setting-up-using-the-breezy-hr-integration#h_dda3bfaf91",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7936681-setting-up-using-the-breezy-hr-integration#h_f8611685c6",
  },
  pinpoint: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7937646-setting-up-using-the-pinpoint-integration#h_a2dae2c261",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7937646-setting-up-using-the-pinpoint-integration#h_92e4bf5fe7",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7937646-setting-up-using-the-pinpoint-integration#h_ceeb919d09",
  },
  recruitly: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7937262-setting-up-using-the-recruitly-integration#h_1a5154cbbd",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7937262-setting-up-using-the-recruitly-integration#h_04381f1b13",
    contactStages:
      "https://help.sourcewhale.app/en/articles/7937262-setting-up-using-the-recruitly-integration#h_98135cb937",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7937262-setting-up-using-the-recruitly-integration#h_d0a6189480",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7937262-setting-up-using-the-recruitly-integration#h_df7929f7eb",
  },
  recruitee: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5477640-setting-up-the-recruitee-integration#h_533438848b",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5477640-setting-up-the-recruitee-integration#h_9eafc06223",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5477640-setting-up-the-recruitee-integration#h_de4b158028",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/5477640-setting-up-the-recruitee-integration#h_e3d9972f34",
  },
  jobdiva: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5918142-setting-up-using-the-jobdiva-integration#h_dc732d3431",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/5918142-setting-up-using-the-jobdiva-integration#h_800bee9330",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5918142-setting-up-using-the-jobdiva-integration#h_d9497bb707",
  },
  hubspot: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6415349-setting-up-the-hubspot-integration#h_ba2dfaef1a",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6415349-setting-up-the-hubspot-integration#h_c5f0eb66b6",
    contactStages:
      "https://help.sourcewhale.app/en/articles/6415349-setting-up-the-hubspot-integration#h_e121a50c42",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6415349-setting-up-the-hubspot-integration#h_7557d243a5",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/6415349-setting-up-the-hubspot-integration#h_477bcd1b34",
  },
  ashby: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6701918-setting-up-the-ashby-integration#h_6000af23e9",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6701918-setting-up-the-ashby-integration#h_fa5f8d4884",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6701918-setting-up-the-ashby-integration#h_2e24763b28",
  },
  airtable: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6891664-setting-up-the-airtable-integration#h_c51984dfab",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6891664-setting-up-the-airtable-integration#h_427569dfc8",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6891664-setting-up-the-airtable-integration#h_17649021e2",
  },
  personio: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7949489-setting-up-using-the-personio-integration#h_d8b05bb86f",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7949489-setting-up-using-the-personio-integration#h_a634c21264",
  },
  mercury: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6769661-setting-up-using-the-mercury-integration#h_f3f7ecf5a5",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6769661-setting-up-using-the-mercury-integration#h_284c2f0b55",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6769661-setting-up-using-the-mercury-integration#h_1fdaf5796b",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/6769661-setting-up-using-the-mercury-integration#h_d0d32f8d2a",
  },
  pump: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7949546-setting-up-using-the-pump-integration#h_7e16c40559",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7949546-setting-up-using-the-pump-integration#h_c8d63d5cc0",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7949546-setting-up-using-the-pump-integration#h_ccc13e0b17",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7949546-setting-up-using-the-pump-integration#h_c0917bd562",
  },
  peopleforce: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7949593-setting-up-the-peopleforce-integration#h_20f1da8b82",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7949593-setting-up-the-peopleforce-integration#h_558338152f",
  },
  googlecontacts: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/5847193-setting-up-the-google-contacts-integration#h_38a97f4cf2",
    contactFields:
      "https://help.sourcewhale.app/en/articles/5847193-setting-up-the-google-contacts-integration#h_f6bef15368",
  },
  voyager: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7996209-setting-up-the-voyager-infinity-integration#h_3dbe5686b0",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7996209-setting-up-the-voyager-infinity-integration#h_be6fb1eff8",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7996209-setting-up-the-voyager-infinity-integration#h_257f0388e4",
  },
  lessannoying: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7949634-setting-up-the-less-annoying-crm-integration#h_77a37ed5de",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7949634-setting-up-the-less-annoying-crm-integration#h_b0180c5630",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7949634-setting-up-the-less-annoying-crm-integration#h_8fd2f1e80c",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7949634-setting-up-the-less-annoying-crm-integration#h_ae567dcb33",
  },
  exelare: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7949510-setting-up-using-the-exelare-integration#h_eafbe11a48",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7949510-setting-up-using-the-exelare-integration#h_cc9f1a9293",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7949510-setting-up-using-the-exelare-integration#h_a3cd7691e5",
  },
  manatal: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7949866-setting-up-using-the-manatal-integration#h_8d617efec3",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7949866-setting-up-using-the-manatal-integration#h_f253e075e1",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7949866-setting-up-using-the-manatal-integration#h_afa4eeb983",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7949866-setting-up-using-the-manatal-integration#h_4c60906d3c",
  },
  dynamics: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7949704-setting-up-the-dynamics-integration#h_8006960a25",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7949704-setting-up-the-dynamics-integration#h_a9df9aa764",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7949704-setting-up-the-dynamics-integration#h_2c3ccfb115",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7949704-setting-up-the-dynamics-integration#h_67ec590c01",
  },
  firefish: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/8263200-setting-up-the-firefish-integration#h_2d43a88f56",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/8263200-setting-up-the-firefish-integration#h_102f8c5330",
    contactFields:
      "https://help.sourcewhale.app/en/articles/8263200-setting-up-the-firefish-integration#h_c8c93fe4fc",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/8263200-setting-up-the-firefish-integration#h_32a3928241",
  },
  seven20: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/6772569-setting-up-the-seven20-integration#h_ef20767626",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/6772569-setting-up-the-seven20-integration#h_e02617cde6",
    contactFields:
      "https://help.sourcewhale.app/en/articles/6772569-setting-up-the-seven20-integration#h_756e4ab88a",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/6772569-setting-up-the-seven20-integration#h_409bc2ad14",
  },
  streak: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7994735-setting-up-the-streak-integration#h_b0d0367eba",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7994735-setting-up-the-streak-integration#h_512663a0d0",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7994735-setting-up-the-streak-integration#h_542db8ba93",
  },
  talentrover: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7994839-setting-up-the-bullhorn-for-salesforce-integration#h_8b00f7d8fc",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7994839-setting-up-the-bullhorn-for-salesforce-integration#h_a9ee31bf01",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7994839-setting-up-the-bullhorn-for-salesforce-integration#h_63d92a6946",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7994839-setting-up-the-bullhorn-for-salesforce-integration#h_22d1513ecd",
  },
  thrive: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/7994842-setting-up-the-thrive-integration#h_48381e922b",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/7994842-setting-up-the-thrive-integration#h_374170324c",
    contactStages:
      "https://help.sourcewhale.app/en/articles/7994842-setting-up-the-thrive-integration#h_31595d12f8",
    contactFields:
      "https://help.sourcewhale.app/en/articles/7994842-setting-up-the-thrive-integration#h_93a8ba8f64",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/7994842-setting-up-the-thrive-integration#h_c7cf38939c",
  },
  bigbiller: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/8263210-setting-up-the-top-echelon-integration#h_6c4aea0696",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/8263210-setting-up-the-top-echelon-integration#h_328f31de6f",
    contactFields:
      "https://help.sourcewhale.app/en/articles/8263210-setting-up-the-top-echelon-integration#h_ebbc39cbb5",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/8263210-setting-up-the-top-echelon-integration#h_73ca9cf14d",
  },
  avionte: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/9453381-setting-up-using-the-avionte-integration#h_b952b0b741",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/9453381-setting-up-using-the-avionte-integration#h_c0175c82ce",
    contactFields:
      "https://help.sourcewhale.app/en/articles/9453381-setting-up-using-the-avionte-integration#h_6b20eaa50c",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/9453381-setting-up-using-the-avionte-integration#h_a334a50c46",
  },
  encore: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/8681610-setting-up-the-encore-integration#h_587ad650be",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/8681610-setting-up-the-encore-integration#h_702da5d501",
    contactStages:
      "https://help.sourcewhale.app/en/articles/8681610-setting-up-the-encore-integration#h_9f95dbeef7",
    contactFields:
      "https://help.sourcewhale.app/en/articles/8681610-setting-up-the-encore-integration#h_e50563a728",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/8681610-setting-up-the-encore-integration#h_df0aad5bb4",
  },
  colleague: {
    contactSettings:
      "https://help.sourcewhale.app/en/articles/10342393-setting-up-the-colleague-integration#h_4e2dca41bf",
    activityNotes:
      "https://help.sourcewhale.app/en/articles/10342393-setting-up-the-colleague-integration#h_4d8b39391b",
    contactFields:
      "https://help.sourcewhale.app/en/articles/10342393-setting-up-the-colleague-integration#h_7f8165132b",
    generalSettings:
      "https://help.sourcewhale.app/en/articles/10342393-setting-up-the-colleague-integration#h_7a1268b4d6",
  },
};

export const getProviderLearnMoreLink = (providerName, page) =>
  page && providerName
    ? PROVIDER_LINKS[providerName.toLowerCase()]?.[page] || null
    : null;
